module.exports = __webpack_public_path__ + "static/2-fa21c075298bc7d1cdb375df12a84da0.png";